export default "__VITE_ASSET__Mprsg23v__"